export default __webpack_public_path__ + "static/taskdefinition24-dd71a6c3b9f9ddd473d4a7ad5d9c345f.png";